import { TagNeedsReview } from "../api/models";
import Emails from "../components/Emails";

const AllEmails = () => {
    return (
        <Emails/>
    );
};
export default AllEmails;
